import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-more-options',
    templateUrl: './more-options.component.html',
    styleUrls: ['./more-options.component.scss'],
    standalone: false,
})
export class MoreOptionsComponent {
    @Input() disableDuplicate: boolean = false;
    @Input() disableOptions: boolean = false;
    @Input() disableDelete: boolean = false;
    @Output() onDeleteEmitter = new EventEmitter();
    @Output() onEditEmitter = new EventEmitter();
    @Output() onDuplicateEmitter = new EventEmitter();
    constructor() {}

    async delete(event: MouseEvent) {
        if (this.disableOptions || this.disableDelete) return;
        event.stopImmediatePropagation();
        this.onDeleteEmitter.emit();
    }

    edit(event: MouseEvent) {
        if (this.disableOptions) return;
        event.stopImmediatePropagation();
        this.onEditEmitter.emit();
    }

    duplicate(event: MouseEvent) {
        if (this.disableDuplicate || this.disableOptions) return;
        event.stopImmediatePropagation();
        this.onDuplicateEmitter.emit();
    }
}
